/**
 * Shared "variant changed → morph this element" behavior for PDP sections that read
 * variant-level metafields (specifications, worn gallery, materials & craft images).
 *
 * Horizon's <variant-picker> in sections/pdp-buy-box.liquid is not inside any of the
 * sections special-cased in assets/variant-picker.js's SECTION_ID_MAP, so it falls back to
 * fetching the *whole* product page on selection (no `section_id` param — see that file's
 * buildRequestUrl()), not just its own section. sections/pdp-buy-box.liquid's own
 * assets/pdp-buy-box.js already relies on this to morph its own selectors from the fetched
 * HTML; this file extends the same `shopify:product:select` event to any other element on
 * the page, so each variant-reactive PDP section can subscribe independently instead of
 * cramming unrelated modules into the buy box section.
 *
 * Usage: give the element that should update itself a `data-pdp-morph-root` attribute whose
 * value is a CSS selector matching that same element (e.g.
 * `data-pdp-morph-root=".system-section"`). One listener here handles every tagged element
 * on the page.
 */
import { morph } from '@theme/morph';

document.addEventListener('shopify:product:select', async (event) => {
  const targets = document.querySelectorAll('[data-pdp-morph-root]');
  if (!targets.length) return;

  let resolved;
  try {
    resolved = await event.promise;
  } catch (error) {
    return;
  }

  const html = resolved?.detail?.html;
  if (!html) return;

  targets.forEach((current) => {
    const selector = current.dataset.pdpMorphRoot;
    const next = selector && html.querySelector(selector);
    if (next) morph(current, next);
  });
});
